export const LOGIN_PATH = '/'
export const RESET_PASSWORD_PATH = '/reset_password'
